// 江
// let prefix = 'http://192.168.10.24:8084/platform_tran_oview',
//   PREVIEW_IMG = 'http://192.168.10.24:8089/tem/',
//   PUBLIC_IMG = 'http://192.168.10.24:8089/public/',
// 现网
let prefix = 'https://www.sd235.net/platform_tran_oview/local',
  PREVIEW_IMG = 'https://tmp.sd235.net:8088/tem/',
  PUBLIC_IMG = 'https://tmp.sd235.net:8088/public/',
  SERVER_PATH = 'https://sd235.oss-cn-shanghai.aliyuncs.com/';
let api = {
  // 增加播放数量 sd
  ADDPLAYCOUNT: '/convoice/addPlayCount',
  // 增加下载量 sd
  ADDDOWNLOADCOUNT: '/convoice/addDownloadCount',
  // 查询在线IM客服
  ONLINEWAITERLIST: '/user/onlineWaiterList',
  // 查询订单
  FINDMYORDER: '/customerOrder/findMyOrder',
  // 客服手动创建非正常订单
  IMPROPERCREATEORDER: '/customerOrder/improperCreateOrder',
  // 客服手动单个创建订单填写需求信息
  SINGLECREATEORDER: '/customerOrder/singleCreateOrder',
  // 根据订单查询试音
  FINDMYAUDITION: '/customerOrder/findMyAudition',
  // 注册
  REGISTER: '/user/register',
  // 修改密码
  UPDATEPWD: '/user/updatePwd',
  // 登出
  LOGINOUT: '/user/loginOut',
  // 登录
  LOGIN: '/user/login',
  // 发送注册手机验证码
  GETVERIFYCODE: '/user/getVerifyCode',
  // 忘记密码
  FORGETPASS: '/user/forgetPass',
  // 忘记密码获取验证码
  GETFORGETCODE: '/user/getForgetCode',
  // 上传文件
  UPLOAD: '/datum/upload',
  // 根据字典类型查询该类型下的字典
  FINDDICT: '/customerOrder/findDict',
  // 验证老客户电话是否存在
  CHECKPHONE: '/user/checkPhone',
  // 老客户添加电话
  UPDATEOLDUSERPHONE: '/user/updateOldUserPhone',
  // 根据稿件id查询稿件详情
  GETCONTRIBUTIONBYID: '/customerOrder/getContributionById',
  // 修改用户信息
  UPDATEMYINFO: '/user/updateMyInfo',
  // 查询用户信息
  GETCUSTOMERINFO: '/user/getCustomerInfo',
  // 客户订单统计
  GETSTATISTICSBYCUSTOMERSEARCH: '/customerOrder/getStatisticsByCustomerSearch',
  // 查询发票
  GETTRANINVOICEBYSEARCH: '/customerInvoice/getTranInvoiceBySearch',
  // 查询发票详情
  FINDTRANINVOICEINFOBYID: '/customerInvoice/findTranInvoiceInfoById',
  // 添加用户地址
  ADDUSERADDRESS: '/customerInvoice/addUserAddress',
  // 添加发票title
  ADDINVOICEINFO: '/customerInvoice/addInvoiceInfo',
  // 用户查询地址
  GETADDRESSBYUSERID: '/customerInvoice/getAddressByUserId',
  // 用户查询发票信息
  GETUSERINVOICEBYUSERID: '/customerInvoice/getUserInvoiceByUserId',
  // 客户提交发票
  WAITERADDINVOICEAPPLY: '/customerInvoice/waiterAddInvoiceApply',
  // 更新用户地址
  UPDATEUSERADDRESS: '/customerInvoice/updateUserAddress',
  // 更新用户发票信息
  UPDATEUSERINVOICE: '/customerInvoice/updateUserInvoice',
  // 删除用户地址
  DELETEUSERADDRESS: '/customerInvoice/deleteUserAddress',
  // 删除用户发票信息
  DELETEUSERINVOICEBYID: '/customerInvoice/deleteUserInvoiceById',
  // 客户查询客服信息
  GETINTERNALINFO: '/user/getInternalInfo',
  // 通过QQ一键注册
  REGISTBYQQ: '/user/registByQQ',
  // 并登录
  LOGINBYMAIL: '/user/loginByMail',
  // 通过QQ邮箱重置密码
  FINDPASSBYMAIL: '/user/findPassByMail',
  // 检查uuid
  CHECKUUID: '/user/checkUUID',
  // 修改密码
  UPDATESYSUSERPWDBYUUID: '/user/updateSysUserPwdByUUID',
  // 查询支付记录
  SEARCHPAYRECORD: '/customerPay/searchPayRecord',
  // 查询当前余额
  SEARCHCUSTOMERAMOUNT: '/customerPay/searchCustomerAmount',
  // 查询充值记录
  SEARCHCUSTOMERRECHARGES: '/customerPay/searchCustomerRecharges',
  // 查询提现记录
  SEARCHCUSTOMEREXTRACT: '/customerPay/searchCustomerExtract',
  // 取消支付
  CLOSEPAYORDER: '/customerPay/closePayOrder',
  /*** 新找回密码相关 ***/

  // 客户查询客服信息
  GETINTERNALINFO: '/user/getInternalInfo',
  // 通过QQ一键注册
  REGISTBYQQ: '/user/registByQQ',
  // 根据qq邮件中链接完成注册并登录
  LOGINBYMAIL: '/user/loginByMail',
  // 通过QQ邮箱重置密码
  FINDPASSBYMAIL: '/user/findPassByMail',
  // 发送注册手机验证码
  REGISTVERIFYCODE: '/user/getVerifyCode',
  // 老用户添加手机
  BOUNDPHONE: '/user/updateOldUserPhone',
  // 查询在线IM客服
  ONLINEWAITERLIST: '/user/onlineWaiterList',

  // 图形验证码
  IMGVERIFYCODE: '/datum/imgVerifyCode',
  //checkUuid
  CHECKUUID: '/user/checkUUID',
  //重置密码
  UPDATESYSUSERPWDBYUUID: '/user/updateSysUserPwdByUUID',

  // 每日签到
  SIGNIN: '/point/signIn',
  // 客户添加收藏品
  CUSTOMERCOLLECT: '/point/customerCollect',
  // 客户查看收藏品
  CUSTOMERFINDCOLLECTION: '/point/customerFindCollection',
  // 客户取消收藏品
  CUSTOMERCANCELCOLLECTION: '/point/customerCancelCollection',
  // 查看藏品被哪些客户收藏
  GETCOLLECTORS: '/point/getCollectors',
  // 顾客点赞
  CUSTOMERUPVOTE: '/point/customerUpvote',
  // 点赞统计信息
  GETUPVOTESTATISTICS: '/point/getUpvoteStatistics',
  // 收藏统计信息
  GETCOLLECTSTATISTICS: '/point/getCollectStatistics',
  // 客户查看收藏品ids
  CUSTOMERFINDCOLLECTIONIDS: '/point/customerFindCollectionIds',
  // 收藏分类下搜索
  GETCOLLECTIONBYCONDITION: '/point/getCollectionByCondition',
  // 提交订单
  CUSTOMERSUBMITPAY: '/customerPay/customerSubmitPay',
  // 在线充值
  UPDATEAMOUNTBYRECHARGE: '/customerPay/updateAmountByRecharge',
  // 查询订单集合支付情况
  FINDPAYRESULTBYPAYID: '/customerPay/findPayResultByPayId',
  //添加订单评论
  ADDTRANAPPRAISEINFO: '/appraise/addTranAppraiseInfo',

  /* >>>>>>>>>>>>>> 优惠券 <<<<<<<<<<<<< */

  // 查询我的优惠券
  FINDMYDISCOUNT: '/discount/findMyDiscount',
  // 交易时,查询我可以用的优惠卷
  FINDCANUSERDISCOUNT: '/discount/findCanUserDiscount',
  // 根据id查询个人优惠券信息
  FINGDISCOUNTUSERBYCODE: '/discount/fingDiscountUserByCode',
  // 领券
  UPDATECLAIMDISCOUNT: '/discount/updateClaimDiscount',
  // 查询优惠券列表
  FINDDISCOUNT: '/discount/findDiscount',
  // 查询用户已经领了的并且没有过期的优惠券
  GETCUSTOMERALLDISCOUNT: '/discount/getCustomerAllDiscount',

  /* >>>>>>>>>>>>>> 优惠券 <<<<<<<<<<<<< */
  /*>>>>>>>>>>>>>>>>消息 <<<<<<<<<<<<<<<<*/
  //根据条件查询消息
  GETMYINFORMATION: '/information/getMyInformation',
  //根据id查询消息
  GETMYINFORMATIONBYID: '/information/getMyInformationById',
  //删除消息
  DELETEMESSAGEBYID: '/information/deleteMessageById',
  //查看未读消息数量
  GETINFOCOUNT: '/information/getInfoCount',
  /*>>>>>>>>>>>>>>>>消息 <<<<<<<<<<<<<<<<*/
  //推荐统计
  GETRETURNCASHINFO: '/customerOrder/getReturnCashInfo',
  //导出表格
  DOWNLOADORDERINFO: '/customerOrder/downloadOrderInfo',
  //企业认证 身份认证
  CUSTOMERAPPLYIDENTIFY: '/customerIdentify/customerApplyIdentify',
  //查看认证
  CUSTOMERCHECKIDENTIFY: '/customerIdentify/customerCheckIdentify',
  // 生成小程序二维码
  GETSMALLPROCEDURE: '/customerOrder/getSmallProcedure',
  // 根据tagId查询在线支付渠道
  FINDONLINEPAYCHANNEL: '/link_pay/findOnLinePayChannel',
  //查询客户最后一次充值是什么标签
  FINDLASTRECHARGECHANNELBYCUSTOMERID: '/link_pay/findLastRechargeChannelByCustomerId',
  //查询客户最后一次支付是什么标签
  FINDLASTPAYCHANNELBYCUSTOMERID: '/link_pay/findLastPayChannelByCustomerId',

  //deep后台跳转到前台
  //前台通过加密的买家id一键登录
  LOGINBYCUSTOMERID: '/link_pay/loginByCustomerId',
  // 获取所有客服
  GETALLINNERUSER: '/customerOrder/getAllInnerUser'
};

function filterPath(path) {
  path = path.replace(/\\/g, '/');
  return path;
}
export function getAPI(name) {
  return prefix + api[name];
}
export function getIMG(path) {
  return filterPath(PUBLIC_IMG + path);
}
export function getPREIMG(path) {
  return filterPath(PREVIEW_IMG + path);
}
export function allAPI() {
  let apis = {};
  for (let i in api) {
    apis[i] = getAPI(i);
  }
  apis['OSS'] = getOSS('');
  apis['IMG'] = getIMG('');
  apis['PRE'] = getPREIMG('');
  return apis;
}
export function getOSS() {
  return SERVER_PATH;
}



// WEBPACK FOOTER //
// ./src/service/data.api.js